/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React Helper Functions
import pxToRem from "assets/theme/functions/pxToRem";

const cardContent = {
  styleOverrides: {
    root: {
      // ✅ Padding interne horizontal et vertical
      padding: `${pxToRem(20)} ${pxToRem(24)}`,

      // ✅ Coins arrondis uniformes (équivaut à 1rem)
      borderRadius: pxToRem(16),

      // ✅ Couleur de fond propre pour une carte (blanc)
      backgroundColor: "#ffffff",

      // ✅ Ombre douce pour un effet de profondeur léger
      boxShadow: "0px 2px 12px rgba(0, 0, 0, 0.05)",

      // ✅ Transition fluide en cas d’effet hover ou de changement
      transition: "all 0.3s ease-in-out",
    },
  },
};

export default cardContent;
